import { component } from "picoapp";
const observerConfig = { childList: true, subtree: true };

const reviewsProductData = {
  "always-essential-cooking-pan": {
    launchDate: "04/10/23",
    reviewSelector: ".yotpo-syndication-reference",
    reviewText: "Reviewed on: Original Always Pan",
  },
  "mini-always-pan": {
    launchDate: "07/17/23",
    reviewSelector: ".yotpo-footer",
    reviewText: "Reviewed on: Mini Always Pan",
  },
  "mini-perfect-pot": {
    launchDate: "07/17/23",
    reviewSelector: ".yotpo-footer",
    reviewText: "Reviewed on: Mini Perfect Pot",
  },
};

const updateYotpoReviews = (node, observer, target) => {
  const yotpoReviews = [...document.querySelectorAll(".yotpo-review")];
  const productHandle = node.dataset.productHandle;
  if (!reviewsProductData[productHandle]) return;
  const reviewElements = yotpoReviews.filter((reviewElement) =>
    reviewElement.querySelector(
      reviewsProductData[productHandle].reviewSelector
    )
  );

  if (!observer) {
    const callback = (_, observer) => {
      updateYotpoReviews(node, observer, target);
    };
    observer = new MutationObserver(callback);

    observer.observe(target, observerConfig);
  }

  const launchDate = new Date(reviewsProductData[productHandle].launchDate);
  const launchDateUTC = launchDate.getTime();
  reviewElements.forEach((reviewElement) => {
    const dateString =
      reviewElement.querySelector(".yotpo-review-date").innerText;
    const date = new Date(dateString);
    const UTCtime = date.getTime();
    if (UTCtime < launchDateUTC) {
      const newSyndicatedElement = document.createElement("div");
      newSyndicatedElement.innerHTML =
        reviewsProductData[productHandle].reviewText;
      const reviewFoooter = reviewElement.querySelector(".yotpo-footer");
      observer.disconnect();
      reviewFoooter.append(newSyndicatedElement);
    }
  });
  observer.observe(target, observerConfig);
};

export default component((node, ctx) => {
  let observer;
  const targetNode = document.querySelector(".yotpo.yotpo-main-widget");
  if (node.querySelector(".yotpo-review-date")) {
    updateYotpoReviews(node, observer, targetNode);
  } else {
    const callback = (mutationList, observer) => {
      updateYotpoReviews(node, observer, targetNode);
    };
    observer = new MutationObserver(callback);

    observer.observe(targetNode, observerConfig);
  }

  return () => {
    if (observer) {
      observer.disconnect();
    }
  };
});
